import React from "react";
import Reserve_form from "./form";
import Reserve_header from "./header";

function Reserve_content(){

    return(
        <div id="reserve">
            <Reserve_header />
            <Reserve_form />
        </div>
    );

}

export default Reserve_content;